import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import VueCookies from 'vue-cookie'
import AsyncComputed from 'vue-async-computed'

Vue.config.productionTip = false
Vue.use(VueCookies)
Vue.use(AsyncComputed)

const eventBus = new Vue();

new Vue({
  router,
  vuetify,
  render: h => h(App),
  data: {
    eventBus
  }
}).$mount('#app')
